import { format } from "date-fns";
import { axiosApiInstance } from "../../../pages/api/axios";
import { safeLocalStorage } from "../../../utils/safeLocalStorage";

export const discountDurations: Record<string, string> = {
  first_cycle: "First cycle",
  all_cycles: "All cycles",
  custom: "Custom",
};

export const recurrencesOptions = {
  null: "Forever",
  1: "1 cycle",
  3: "3 cycles",
  6: "6 cycles",
  custom: "Custom",
};

export const createSubscription = (data: any) => {
  return axiosApiInstance
    .post(`/d/subscriptions/`, data)
    .then((res) => res.data.data);
};

export const getSubscription = (id: any) => {
  return axiosApiInstance.get(`/d/subscriptions/${id}/`).then((res) => {
    const subscription = (res.data as any).data;
    return {
      ...(res.data as any),
      data: {
        ...subscription,
        account: subscription.account.id,
        accountName: subscription.account.name,
        customer: subscription.customer.id,
        customerName: subscription.customer.name,
        plan: subscription.plan.id,
        planName: subscription.plan.name,
        start_date: format(new Date(subscription.start_date), "yyyy-MM-dd"),
        end_date:
          subscription.end_date &&
          format(new Date(subscription.end_date), "yyyy-MM-dd"),
        custom_fields: {
          ...subscription.custom_fields,
          discount_type: subscription?.custom_fields?.discount_amount
            ? "fixed_amount"
            : "percentage_discount",
        },
      },
    };
  });
};

export const getAccounts = (search: string) => {
  return axiosApiInstance.get(`/d/accounts/`, {
    params: {
      offset: 0,
      limit: 10,
      search,
    },
  });
};

export const getAccountCustomersWithSearch = (searchKeyword = undefined) => {
  const params = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    (params as any).search = searchKeyword;
  }
  return axiosApiInstance.get(`/d/customers/`, {
    params,
  });
};

export const getPlans = (params: any) => {
  return axiosApiInstance.get(`/d/subscriptions/plans/`, {
    params,
  });
};

export const getPlansWithSearch = (searchKeyword = undefined) => {
  const params = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    (params as any).search = searchKeyword;
  }
  return axiosApiInstance.get(`/d/subscriptions/plans/`, {
    params,
  });
};

export const createPlan = (data: any) => {
  return axiosApiInstance
    .post(`/d/subscriptions/plans/`, data)
    .then((res) => res.data.data);
};

export const getOrganizationCurrencies = () => {
  const orgId = safeLocalStorage.getItem("user-org-id");

  return axiosApiInstance.get(`/d/organizations/${orgId}/currencies/`, {
    params: { offset: 0, limit: 200 },
  });
};

export const getPlan = (id: any) => {
  return axiosApiInstance
    .get(`/d/subscriptions/plans/${id}/`)
    .then((res) => res.data);
};

export const createPlanGroup = (payload: any) => {
  return axiosApiInstance
    .post(`/d/subscriptions/plan-groups/`, payload)
    .then((res) => res.data.data);
};

export const updatePlanGroup = (id: any, payload: any) => {
  return axiosApiInstance
    .patch(`/d/subscriptions/plan-groups/${id}/`, payload)
    .then((res) => res.data.data);
};
